(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function initGroupMarquees() {
      document.querySelectorAll('[data-group-marquee]').forEach(function (root) {
        if (root.hasAttribute('data-group-marquee-ready')) return;
        if (root.querySelector('.group-block-content--design-mode')) return;

        var wrapper = root.querySelector('[data-group-marquee-wrapper]');
        var content = root.querySelector('[data-group-marquee-content]');
        if (!wrapper || !content) return;

        root.setAttribute('data-group-marquee-ready', '');

        var clone = content.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(function (el) {
          el.removeAttribute('id');
        });
        wrapper.appendChild(clone);
        root.classList.add('group-block--marquee-ready');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGroupMarquees);
    } else {
      initGroupMarquees();
    }

    document.addEventListener('shopify:section:load', initGroupMarquees);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["per-serving"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const html = event.detail?.data?.html;
    const productId = event.detail?.data?.productId;
    if (!html) return;

    const next = html.querySelector('.per-serving-cost');
    document.querySelectorAll('.per-serving-cost').forEach((current) => {
      if (productId && current.dataset.productId && current.dataset.productId !== productId) return;

      const wrapper = current.closest('.per-serving');
      if (!next || !next.textContent.trim()) {
        current.hidden = true;
        if (wrapper) wrapper.hidden = true;
        return;
      }

      current.hidden = false;
      if (wrapper) wrapper.hidden = false;
      current.textContent = next.textContent;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
